<script>
export default {
  name: 'BlockCard',
  props: {
    selected: Boolean,
    block: Object
  }
};
</script>

<template>
  <div :class="{'block-card': true, selected}" @click="$emit('click', $event)">
    <div class="block-card-icon">
      <i class="el-icon-fa-cube" />
    </div>
    <div class="block-card-name">
      <router-link
        :to="{
          name: 'EditBlock',
          params: {
            siteId: block.siteId,
            blockId: block.id
          }
        }"
      >
        {{ block.name }}
      </router-link>
    </div>
    <div class="block-card-description">
      {{ block.description }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.block-card {
  display: block;
  position: relative;
  background: $--color-white;
  border-top: solid 1px darken($--color-gray-10, 2.5%);
  box-shadow: $--box-shadow-small;
  padding: 1.5rem 1.25rem 1.5rem 4rem;
  user-select: none;

  &:first-child {
    border-top: none;
  }

  &.selected {
    background-color: $--color-primary-light-9;
    border-top-color: darken($--color-primary-light-9, 5%);
    color: $--color-primary;

    .block-card-icon,
    .block-card-name,
    .block-card-description {
      color: inherit;
    }

    .block-card-icon {
      color: darken($--color-primary-light-9, 10%);
    }
  }

  &.selected:last-child {
    border-bottom-color: darken($--color-primary-light-9, 5%);
  }

  &.selected + .block-card {
    border-top-color: darken($--color-primary-light-9, 5%);
  }
}

.block-card-icon {
  position: absolute;
  top: 1rem;
  left: 1rem;
  font-size: 1.8rem;
  color: $--color-gray-20;
}

.block-card-description {
  font-size: $--font-size-small;
  color: $--color-gray-40;
  padding-right: 1.5rem;
  margin: .25rem 0 0 0;
}
</style>
